<div class='top-level'>
  <div class = 'main'>
    <div class='content-top'>
      <div class='email-section'>
        <span class="material-symbols-outlined"> mail_outline </span>
        <label class='email'>{{referral.emailId}}</label>
      </div>
      @if (showAppReferralType) {
        <div>
          <label class='label'>Referral Type: </label><span class='normal-text'>{{referral.referralType}}</span>
        </div>
      }
      <div>
        <label class='label'>Referral ID: </label><span class='normal-text'>{{referral.referralId}}</span>
      </div>
    </div>
    <div class="topi" [ngClass]="{'topi-completed-color' : progressPercent>=25?true:false}">

    </div>
    @if (!isPassiveReferralView) {
      <div class='right-border' [ngClass]="{'completed-mobile-color' : progressPercent>=25?true:false}">
        <div class='left-end' [ngClass]="{'completed-color' : progressPercent>=25?true:false}">
          <label class='heading'>Email Sent</label>
        </div>
        <div class='body'>
          {{referral.emailSent}}
        </div>
      </div>
    }
    <div class='right-border' [ngClass]="{'completed-mobile-color' : progressPercent>=75?true:false}">
      <div [class.middle]="!isPassiveReferralView" [class.left-end]="isPassiveReferralView" [ngClass]="{'completed-color' : progressPercent>=50?true:false}">
        <label class='heading'>{{ clickedStarted }}</label>
      </div>
      @for (clickTime of referral.clicked; track $index; let i = $index) {
        <div class='body'>
          {{clickTime}}
        </div>
      }
    </div>
    @if (showAppInProgressStep) {
      <div class='right-border' [ngClass]="{'completed-mobile-color' : progressPercent>=75?true:false}">
        <div class='middle' [ngClass]="{'completed-color' : progressPercent>=75?true:false}">
          <label class='heading'>App In Progress</label>
        </div>
        @for (app of referral.inProgressApps; track app) {
          <div class='body'>
            {{app.applicationId}}  {{app.timereference}}
          </div>
        }
      </div>
    }
    <div class='content' [ngClass]="{'completed-mobile-color' : progressPercent>=100?true:false}">
      <div class='right-end' [ngClass]="{'completed-color' : progressPercent>=100?true:false}">
        <label class='heading' >App Submitted</label>
      </div>
      @for (app of referral.submittedApps; track app) {
        <div class='body'>
          {{app.applicationId}}  {{app.timereference}}
        </div>
      }
    </div>
    <div class="nikkar" [ngClass]="{'nikkar-completed-color' : progressPercent>=100?true:false}"></div>
  </div>
  <div class='line'></div>
</div>
